export default __webpack_public_path__ + "static/media/view.1bdeaf1e.jpg";